import { renderHeader } from './Header';
import { recalcAndRender } from '../render';
import { router, startRouter } from '../router';
import { appState } from '../state';
import { renderOnboarding } from './Onboarding';
import { renderUpload } from './Upload';
import { renderReview } from './Review';
import { renderSuggest } from './Suggest';
import { renderSettings } from './Settings';
import { refreshIcons } from '../icons';
import { metaGet } from '@/storage/repo';
import { initTheme } from '../theme';

export async function mountApp(root: HTMLElement) {
  await initTheme();

  // Re-hydrate persisted state from the DB before the first render.
  // Without this, only the theme survives a reload — currentMonth,
  // income, amountsHidden and filter silently revert to defaults.
  const [onboarded, income, currentMonth, filter, amountsHidden] = await Promise.all([
    metaGet('onboarded'),
    metaGet('income'),
    metaGet('currentMonth'),
    metaGet('filter'),
    metaGet('amountsHidden'),
  ]);
  appState.set((s) => ({
    ...s,
    onboardingDone: !!onboarded,
    income:         income         ? Number(income)     : s.income,
    currentMonth:   currentMonth   ?? s.currentMonth,
    filter:         (filter as any) ?? s.filter,
    amountsHidden:  amountsHidden === '1',
  }));

  startRouter();
  appState.subscribe(() => renderApp(root));
  router.subscribe(() => renderApp(root));
  renderApp(root);
}

function renderApp(root: HTMLElement) {
  const route = router.get();
  const onboarded = appState.get().onboardingDone;

  if (!onboarded && route === 'home') {
    root.innerHTML = `
      <div class="min-h-screen flex flex-col">
        <div id="headerSlot"></div>
        <div id="mainContent" class="flex-1"></div>
      </div>
    `;
    renderHeader(document.getElementById('headerSlot')!);
    renderOnboarding(document.getElementById('mainContent')!);
    refreshIcons();
    return;
  }

  root.innerHTML = `
    <div class="min-h-screen flex flex-col">
      <div id="headerSlot"></div>
      <div id="mainContent" class="flex-1"></div>
    </div>
  `;
  renderHeader(document.getElementById('headerSlot')!);
  refreshIcons();

  const main = document.getElementById('mainContent')!;
  switch (route) {
    case 'home':     void recalcAndRender(); break;
    case 'upload':   renderUpload(main); break;
    case 'review':   renderReview(main); break;
    case 'suggest':  renderSuggest(main); break;
    case 'settings': renderSettings(main); break;
  }
}

